/**
 * @generated SignedSource<<6676bda0a6cd64ca5692849d0b0be0f7>>
 * @relayHash 1588689852591df823612a1170180898
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1588689852591df823612a1170180898

import { ConcreteRequest } from 'relay-runtime';
export type useChatTranscriptQuery$variables = {
  id: string;
};
export type useChatTranscriptQuery$data = {
  readonly appointmentById: {
    readonly chatDetails: {
      readonly chatThreadId: string;
    } | null;
    readonly chatTranscript: string | null;
  } | null;
};
export type useChatTranscriptQuery = {
  response: useChatTranscriptQuery$data;
  variables: useChatTranscriptQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chatTranscript",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AppointmentChatDetails",
  "kind": "LinkedField",
  "name": "chatDetails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chatThreadId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChatTranscriptQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Appointment",
        "kind": "LinkedField",
        "name": "appointmentById",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChatTranscriptQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Appointment",
        "kind": "LinkedField",
        "name": "appointmentById",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "1588689852591df823612a1170180898",
    "metadata": {},
    "name": "useChatTranscriptQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "39a8f64a53b409dada2c2f6841bda606";

export default node;
